// Enums
export enum RecommendationStatus {
  RECOMMENDED = 'RECOMMENDED',
  SEAL_OF_APPROVAL = 'SEAL_OF_APPROVAL',
  ITS_ALRIGHT = 'ITS_ALRIGHT',
  DO_NOT_RECOMMEND = 'DO_NOT_RECOMMEND',
  WANT_TO_VISIT = 'WANT_TO_VISIT',
}

export enum Category {
  FOOD = 'FOOD',
  DRINKS = 'DRINKS',
}

export enum RequestStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

// Models
export interface User {
  uid: string;
  username: string;
  displayName: string;
  photoURL?: string;
  friends: string[]; // Array of UIDs
  emailConfirmedAt?: string | null;
  email?: string;
  isAdmin?: boolean;
}

export interface Venue {
  venueId: string;
  name: string;
  lat: number;
  lng: number; 
  googlePlaceId?: string;
  category: Category;
  isCustom: boolean;
}

export interface Shout {
  id: string;
  venueId: string;
  userId: string;
  status: RecommendationStatus;
  description: string;
  createdAt: string; // ISO String
}



export interface FriendRequest {
  id: string;
  senderId: string;
  receiverId: string;
  status: RequestStatus;
  createdAt: string; // ISO String
}

export interface Feedback {
  id: string;
  userId: string;
  type: 'good' | 'bad';
  description: string;
  status: 'open' | 'closed';
  createdAt: string;
}

export interface FeedbackComment {
  id: string;
  feedbackId: string;
  userId: string;
  content: string;
  createdAt: string;
  user?: User; // Populated
}

export interface FeatureRequest {
  id: string;
  userId: string;
  title: string;
  description: string;
  status: 'suggested' | 'in_progress' | 'complete';
  createdAt: string;
  voteCount?: number; // Populated
  hasVoted?: boolean; // Populated
  user?: User; // Populated
}
// Social
export interface GoodShout {
    id: string;
    shoutId: string;
    userId: string;
    message: string;
    createdAt: string;
}

export interface PopulatedGoodShout extends GoodShout {
    user: User;
}

export interface FeatureVote {
  id: string;
  featureId: string;
  userId: string;
  createdAt: string;
}

export type FollowPreset = 'TOP_PICKS' | 'RECOMMENDATIONS' | 'EVERYTHING';

export interface ShoutFollow {
  followerId: string;
  followedId: string;
  notifyPreset: FollowPreset;
  createdAt: string;
}

// Notifications
export type NotificationType = 'friend_request' | 'friend_accepted' | 'good_shout' | 'new_shout';

export interface AppNotification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  data?: {
    senderId?: string;
    shoutId?: string;
    venueId?: string;
  };
  createdAt: string;
  readAt?: string | null;
}

// Helper Types
export interface PopulatedShout extends Shout {
  user: User;
  goodShouts: PopulatedGoodShout[];
  venues?: Venue;
}

export interface PopulatedVenue extends Venue {
  shouts: PopulatedShout[];
  primaryStatus: RecommendationStatus; // Derived logic
}

export interface PlaceSearchResult {
  id: string;
  name: string;
  address: string;
  lat: number;
  lng: number;
}

// Augment window for Google Maps
declare global {
  interface Window {
    google: any;
  }
}